import { aiAudioService } from '../index.js'

// 病历采集相关API - 使用AI音频服务
export const surveyApi = {
  /**
   * 开始病历采集
   * @returns {Promise}
   */
  startSession: () => {
    return aiAudioService({
      url: '/api/sleep/medical/start',
      method: 'post',
      data: {}
    })
  },

  /**
   * 发送文字回答
   * @param {Object} data
   * @param {string} data.session_id - 会话ID
   * @param {string} data.user_message - 用户消息
   * @returns {Promise}
   */
  sendTextAnswer: (data) => {
    return aiAudioService({
      url: '/api/sleep/medical/reply',
      method: 'post',
      data
    })
  },

  /**
   * 发送语音回答
   * @param {Object|FormData} data
   * - JSON 形式：{ session_id: string, audio_filename: string }（旧格式）
   * - FormData 形式：包含 session_id 和 file 字段（新格式，文件上传）
   * @returns {Promise}
   */
  sendAudioAnswer: (data) => {
    return aiAudioService({
      url: '/api/sleep/medical/reply-voice',
      method: 'post',
      data
      // 拦截器会自动检测 FormData 并删除 Content-Type，让浏览器自动设置
    })
  },

  /**
   * 获取病历结果（包含二维码）
   * @param {Object} data
   * @param {string} data.session_id - 会话ID
   * @returns {Promise}
   */
  getConversationResult: (data) => {
    return aiAudioService({
      url: '/api/sleep/medical/result',
      method: 'post',
      data
    })
  }
}